import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import toast from "react-hot-toast";
import { Button } from "@/components/ui/button";
import { Save, Store } from "lucide-react";
import CollapsibleSection from "@/components/parametres/CollapsibleSection";
import { Input } from "@/components/Input";
import { RestaurantFranchise, FranchiseUpdatePayload } from "@/redux/services/restaurant/restaurant.type";
import { useUpdateFranchiseMutation } from "@/redux/services/restaurant/restaurant.api";
import { useAppDispatch } from "@/redux/features/hooks";
import { setCurrentFranchise } from "@/redux/features/user/user.slice";
import { cleanerError } from "@/lib/utils";

const schema = yup.object().shape({
  name: yup.string().required().label("Nom"),
});

const InfoFranchise = ({ item }: { item?: RestaurantFranchise }) => {
  const dispatch = useAppDispatch();
  const [update, { isLoading }] = useUpdateFranchiseMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
  } = useForm<FranchiseUpdatePayload>({
    // @ts-ignore
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (errors) {
      cleanerError(errors, clearErrors);
    }
  }, [errors, clearErrors]);

  const onSubmit = async (data: FranchiseUpdatePayload) => {
    const res = await update({ id: item?.id as string, data });

    if ("data" in res) {
      toast.success("Informations de la franchise mises à jour avec succès");
      reset();
      dispatch(setCurrentFranchise(res.data as RestaurantFranchise));
    } else if ("error" in res) {
      toast.error("Une erreur inconnue est survenue");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 [&_input]:py-2 [&_input]:text-sm">
      <CollapsibleSection icon={Store} title="Informations de la franchise">
        <div>
          <Input
            label="Nom de la franchise"
            type="text"
            id="name"
            placeholder="Nom de la franchise"
            defaultValue={item?.name}
            {...register("name")}
            error={errors.name}
          />
        </div>
      </CollapsibleSection>

      <div className="flex justify-end">
        <Button isLoading={isLoading} className="flex items-center gap-2">
          <Save className="h-4 w-4" />
          Enregistrer
        </Button>
      </div>
    </form>
  );
};

export default InfoFranchise;
